<template>
  <div class="-card-view">
    <a class="unit-info" href="/store#store-passes">
      <sale-badge :is-sale="searchStore.init.storeCardSaleAll" />
      <div class="exclusive -opt-03">
        <div class="message">
          <h2 class="heading -primary">
            <span class="fbplus">
              <span class="fb">FB</span>
              <span class="plus">Store</span>
            </span>
            <span class="sub-heading -standard">Plus Passes</span>
          </h2>
          Passes give you full access to everything FB Plus has to offer, without a long-term
          subscription.
        </div>
      </div>
    </a>
  </div>
</template>

<script setup lang="ts">
import { useSearchStore } from '@/stores/search'
import SaleBadge from '@/components/products/sale-badge.vue'

/** PROPS **/
// n/a

/** STATE **/
const searchStore = useSearchStore()
</script>
